<script>
// @ts-check
import ChartTileEntry from '@components/chart-tile-entry'
import { ChartType, Maybe } from '@domain'
import { mapMutations } from 'vuex'

let row1 = [
  ['Attendance', ChartType.AttendanceRates],
  ['STAAR Outcomes', ChartType.STAAROutcomes],
  ['TSIA Data', ChartType.TSIA],
  [
    'Recommended/ Distinguished Achievement Graduates',
    ChartType.DAPRecommendedPlan,
  ],
  ['Advanced/Dual Courses Taken', ChartType.AdvDualCoursesTaken],
]
let row2 = [
  // ['College Enrollment' /*, ChartType.CollegeEnrollment */],
  ['College Readiness', ChartType.CollegeReadiness],
  // ['College Persistence Rates' /*, ChartType.Persistence */],
  // ['Summer Melt Rates'],
  // ['4-year college application rates'],
  // ['4-year college admission rates'],
  // ['FAFSA submission'],
  // ['FAFSA completion'],
  ['SAT/ACT Participation', ChartType.SAToACTParticipation],
]
// let row3 = [
//   ['Industry-based certification completion'],
//   ['CTE concentration rates'],
//   ['3- and 6- year credential attainment rates'],
//   ['Employment rate'],
//   ['Median Earnings'],
// ]

export default {
  components: { ChartTileEntry },
  data: function() {
    return { row1, row2 }
    // return { row1, row2, row3 }
  },
  page: {
    title: 'DataViz',
    meta: [{ name: 'description', content: 'dataViz page...' }],
  },
  created() {
    this.SetChartType(Maybe.Nothing)
    this.ClearCachedState()
  },
  methods: {
    ...mapMutations('wizard', {
      SetChartType: 'SetChartType',
      ClearCachedState: 'ClearCachedState',
    }),
  },
  //Adds Google Analytics and HubSpot tracking tags
  mounted() {
    if (
      window.location.href.indexOf(
        'https://datadive.texasoncourse.org'
      ) > -1
    ) {
      const src = document.createElement('script')
      src.setAttribute('src', "https://www.googletagmanager.com/gtag/js?id=UA-81851309-9")
      src.async = true
      document.head.appendChild(src)

      const GAtag = document.createElement('script')
      GAtag.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'UA-81851309-9');"
      document.head.appendChild(GAtag)

      const HStag = document.createElement('script')
      HStag.type = 'text/javascript'
      HStag.setAttribute('id', "hs-script-loader")
      HStag.async = true
      HStag.defer = true
      HStag.setAttribute('src', "//js.hs-scripts.com/5256511.js")
      document.body.appendChild(HStag)

    }
  },
}
</script>

<template>
  <v-layout justify-center row>
    <v-flex xs7>
      <ChartTileEntry :type="'Secondary School Performance'" :sub-type="row1"/>
      <ChartTileEntry :type="'College Readiness Data'" :sub-type="row2" :color="'green darken-1'"/>
      <!-- <ChartTileEntry
        :type="'Post-Secondary Outcomes'"
        :sub-type="row3"
        :color="'cyan darken-1'"
      />-->
      <div style="margin: 3em 5em;">
        *Data source is the Texas Academic Performance Reports (TAPR). TAPR are reports pulled together by TEA which present a wide range of information on the performance of students in each school and district in Texas every year. For more information, please see
        <a
          href="https://tea.texas.gov/perfreport/tapr/index.html"
        >https://tea.texas.gov/perfreport/tapr/index.html</a>.
      </div>
    </v-flex>
  </v-layout>
</template>
